<div *ngIf="data"
     class="border-b p-3 hover:bg-slate-300 cursor-pointer"
>
  <div [ngSwitch]="data.aggregateTypeId">

    <!-- <pre class="text-xs p-3 bg-slate-800 text-white">{{ data | json }}</pre> -->

    <!-- organization -->
    <a *ngSwitchCase="3" routerLink="/dir/operative/organizations" [queryParams]="{registerId: data.id}" class="flex">
      <div class="flex-1">
        <div>
          <span>{{ data.code }}</span>
          <span> - </span>
          <span class="font-bold">{{ data.legalName }}</span>
        </div>
        <div *ngIf="data.legalName !== data.tradeName || data.parent" class="text-sm mt-2 ml-3">
          <div class="flex items-center">
            <span icon="store" size="1rem" class="mr-3"></span>
            <span>{{ data.tradeName }}</span>
          </div>
          <div *ngIf="data.parent" class="flex items-center">
            <span [icon]="icons[data.parent.aggregateTypeId]" size="1rem" class="mr-3"></span>
            <span class="italic">{{ data.parent.description }}</span>
          </div>
        </div>
      </div>
      <div class="flex-initial">
        <span [icon]="icons[data.aggregateTypeId]"></span>
      </div>
    </a> 
    <!-- product -->
    <a *ngSwitchCase="4" routerLink="/products/operative/products" [queryParams]="{ registerId: data.id }" class="flex">
      <div class="flex-1">
        <div>
          <span>{{ data.code }}</span>
          <span> - </span>
          <span class="font-bold">{{ data.name }}</span>
        </div>
        <div>{{ data.description }}</div>
        <!-- <pre>{{ data | json }}</pre> -->
      </div>
      <div class="flex-initial">
        <span [icon]="icons[data.aggregateTypeId]"></span>
      </div>
    </a> 
    <!-- person -->
    <a *ngSwitchCase="6" routerLink="/dir/operative/people" [queryParams]="{ registerId: data.id }" class="flex">
      <div class="flex-1">
        <div class="font-bold">{{ data.name }}</div>
        <div class="text-sm mt-2 ml-3">
          <div class="flex items-center">
            <span icon="email" iconSize="1rem" class="mr-3"></span>
            <span>{{ data.email }}</span>
          </div>
          <div class="flex items-center">
            <span icon="phone" iconSize="1rem" class="mr-3"></span>
            <span>{{ data.phone }}</span>
          </div>
          <div *ngIf="data.parent" class="flex items-cnt">
            <span [icon]="icons[data.parent.aggregateTypeId]" size="1rem" class="mr-3"></span>
            <span class="italic">{{ data.parent.description }}</span>
          </div>
        </div>
      </div>
      <div class="flex-initial">
        <span [icon]="icons[data.aggregateTypeId]"></span>
      </div>
    </a>
  </div>
</div>